import * as React from 'react'
import { useMemo } from 'react'

import Stack from '@mui/material/Stack'
import { useSelector } from 'react-redux'

import {
  entityPreferredMethodOfContact,
  entityPreferredTimeOfContact,
} from '@user/components/Settings/EntityFormSettings'
import { FormSectionTitle } from '../../FormComponents/FormSectionTitle'
import { BestContactTimeSelect } from '../../FormComponents/BestContactTimeSelect/BestContactTimeSelect'
import { BestContactMethodSelect } from '../../FormComponents/BestContactMethodSelect/BestContactMethodSelect'

import { selectAllEntityFormSettings } from '@user/store/entityFormSettings'
import { useGetFieldActiveStates } from '@user/store/entityFormSettings/hooks/useGetFieldActiveStates'
import { useTidalThemeActive } from '@user/features/TidalThemeToggle'
import { DensityType } from '../../../typings'

type Props = {
  hideOptional: boolean
}

export function FollowUpInformationSection(props: Props) {
  const { hideOptional } = props
  const tidalThemeActive = useTidalThemeActive()

  const settings = useSelector(selectAllEntityFormSettings)
  const entitySettingsMap = useGetFieldActiveStates(settings, hideOptional)

  const [requiredPreferredMethodOfContact, showPreferredMethodOfContact] =
    entitySettingsMap.get(entityPreferredMethodOfContact) ?? [false, true]

  const [requiredPreferredTimeOfContact, showPreferredTimeOfContact] =
    entitySettingsMap.get(entityPreferredTimeOfContact) ?? [false, true]

  const showSection: boolean = useMemo(
    () => showPreferredMethodOfContact || showPreferredTimeOfContact,
    [showPreferredMethodOfContact, showPreferredTimeOfContact],
  )

  const density: DensityType = tidalThemeActive ? 'normal' : 'compact'

  return showSection ? (
    <Stack gap={2} pb={4}>
      <FormSectionTitle>Follow Up Information</FormSectionTitle>
      <BestContactMethodSelect
        density={density}
        name="preferredMethodOfContact"
        required={requiredPreferredMethodOfContact}
        show={showPreferredMethodOfContact}
      />
      <BestContactTimeSelect
        density={density}
        name="preferredTimeOfContact"
        required={requiredPreferredTimeOfContact}
        show={showPreferredTimeOfContact}
      />
    </Stack>
  ) : null
}
